<template>
  <div v-bind:class="{ 'version-spacing': !isLoggedIn }">
    <PageHeader title="Join"></PageHeader>
    <v-container class="page-bottom">
      <v-row>
        <v-col>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            @submit.prevent="validate"
              id="frmJoin"
          >
            <v-text-field
              v-model="user.userName"
              :rules="[rules.required]"
              label="User name"
              required
            ></v-text-field>

            <v-text-field
              v-model="user.password"
              :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.required]"
              :type="showPass ? 'text' : 'password'"
              label="Password"
              autocomplete="on"
              @click:append="showPass = !showPass"
            ></v-text-field>

            <v-text-field
              v-model="user.email"
              :rules="[rules.required, rules.email]"
              label="Email"
              required
              type="email"
            ></v-text-field>

            <v-text-field
              v-model="user.firstName"
              :rules="[rules.required]"
              label="First Name"
              required
            ></v-text-field>

            <v-text-field
              v-model="user.surname"
              :rules="[rules.required]"
              label="Surname"
              required
            ></v-text-field>

            <v-checkbox 
              v-model="user.acceptTerms"
              :rules="[rules.required]"
              required
              >
                <template v-slot:label>
                  <div>
                    I accept your <router-link :to="{name: 'terms-and-conditions'}">Terms and Conditions</router-link> and <router-link :to="{name: 'privacy-policy'}">Privacy Policy</router-link>
                  </div>
                </template>
            </v-checkbox>
            <div>
              Users must be 18yrs old and older
            </div>
            <v-btn
              block
              outlined
              large
              style="color: #ffffff !important;border: 1px solid #ffb300;"
              :disabled="!valid"
              color="success"
              class="mt-5"
              type="submit"
              id="click-join"
            >
              Join
            </v-btn>
          </v-form>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <router-link :to="{name: 'login'}">Already joined? Log in here</router-link>
        </v-col>
      </v-row>
    </v-container>

    <v-snackbar
      v-model="snackbar"
      :multi-line="true"
      centered
      color="error"
      id="snackbarJoin"
    >
      {{ snackbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <Spinner :overlay="overlay"></Spinner>
  </div>
</template>

<script>
import { CognitoUserAttribute } from "amazon-cognito-identity-js";
import axios from 'axios'
import PageHeader from './../../components/PageHeader';
import Spinner from './../../components/Spinner';
import UserPool from "./../../plugins/UserPool";

export default {
  name: 'join',
  components: {
    PageHeader,
    Spinner
  },
  data: () => ({
    valid: true,
    showPass: false,
    user: {
      userName: '',
      password: '',
      email: '',
      firstName: '',
      surname: ''
    },
    rules: {
      required: value => !!value || 'Required.',
      email: value => /.+@.+\..+/.test(value) || 'E-mail must be valid'
    },
    overlay: false,
    absolute: true,
    snackbar: false,
    snackbarText: ''
  }),
  computed: {
    isLoggedIn () {
      return this.$store.getters.isLoggedIn;
    }
  },
  methods: {
    validate () {
      var scope = this;
      var isValid = scope.$refs.form.validate();
      if(isValid){
        scope.overlay = true;
        scope.join();
      }
    },
    join () {
      var scope = this;
      scope.overlay = true;

      UserPool.signUp(
        scope.user.userName,
        scope.user.password,
        [new CognitoUserAttribute(
          {
            Name: "email",
            Value: scope.user.email
          }
        ),
        new CognitoUserAttribute(
          {
            Name: "given_name",
            Value: scope.user.firstName
          }
        ),
        new CognitoUserAttribute(
          {
            Name: "family_name",
            Value: scope.user.surname
          }
        )],
        null,
        (err, data) => {
          console.log();
          if (err) {
            scope.snackbarText = err.message;
            scope.snackbar = true;
            scope.overlay = false;
            return;
          }

          axios.post('https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/users', {
            userName: scope.user.userName,
            email: scope.user.email,
            firstName: scope.user.firstName,
            surname: scope.user.surname,
            userSub: data.userSub
          }, {
            headers: {
              'Authorization': localStorage.getItem('jwtToken')
            }
          })
            .then(function (response) {

              axios.post('https://rhsrnact8d.execute-api.us-east-2.amazonaws.com/dev/wallets', {
                userId: response.data.id,
                name: 'Default'
              }, {
                headers: {
                  'Authorization': localStorage.getItem('jwtToken')
                }
              })
                .then(function () {
                  scope.overlay = false;
                  scope.$router.push({name: 'confirm', query: {userName: scope.user.userName, email: scope.user.email}});
                })
                .catch(function (error) {
                  console.log(error);
                  scope.overlay = false;
                });
            })
            .catch(function (error) {
              scope.overlay = false;
              console.log(error);
            });
        }
      );
    }
  }
}
</script>